import React, { useMemo } from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { HomeServiceProvider } from "@/models/HomeServiceProviderModel.ts";
import { userFormattedName } from "@/models/UserModel.ts";
import { SelectItem } from "@/uiKit/atoms/inputs/SelectItem.tsx";
import { FormSelectInput } from "@/uiKit/molecules/form/FormSelectInput.tsx";

export type HSPFormFieldProps = {
  name?: string;
  providers: HomeServiceProvider[];
  className?: string;
};

export const HSPFormField: React.FC<HSPFormFieldProps> = ({ name = "homeServiceProviderId", providers, className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  const choices = useMemo(() => {
    const providerChoices = providers.map(value => ({
      displayName: userFormattedName(value.hspFirstname, value.hspLastname),
      value: value.hspId,
    }));
    providerChoices.push({
      displayName: t("diabetesForms.otherHSP"),
      value: "other",
    });
    return providerChoices;
  }, [providers, t]);

  return (
    <FormSelectInput
      id="hsp-form-field"
      name={name}
      label={t("diabetesForms.hsp")}
      className={cx(styles.root, className)}
      reserveErrorSpace
      fullWidth
    >
      {choices.map(item => (
        <SelectItem key={item.value} value={item.value}>
          {item.displayName}
        </SelectItem>
      ))}
    </FormSelectInput>
  );
};

const makeStyles = () => ({
  root: css({}),
});
